import { Builder } from '@builder.io/react';

import Header from 'react-scale/components/pages/transformx/header';

Builder.registerComponent(Header, {
  name: 'TransformX Header',
  inputs: []
});
